import { setHasMultiLegWagersAction } from "@fdr/shared-actions/ProgramPageActions";
import { multiLegWagerTypes } from "@fdr/utils/wagerUtils";
import { FetchPolicy } from "@apollo/client";

import { get } from "lodash";
import { format } from "date-fns";
import type { Props } from "../types";

export const getVariables = (props: Props) => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  const endDate = new Date();
  return {
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
    accountId: parseInt(props.accountNumber, 10),
    wagerTypes: multiLegWagerTypes
  };
};
export default {
  // eslint-disable-next-line
  skip: (props: Props) => {
    return (
      !props.pickBetsOnboardingToggle ||
      !props.accountNumber ||
      !multiLegWagerTypes.includes(get(props, "wagerType.type.code")) ||
      props.hasMultiLegWagers !== undefined
    );
  },
  // eslint-disable-next-line
  options: (props: Props) => {
    return {
      fetchPolicy: "cache-and-network" as FetchPolicy,
      client: props.behgClient,
      ssr: false,
      variables: getVariables(props)
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: (result: any) => {
    const totalCount = +get(result, "data.wagerHistory.totals.totalCount");
    const hasMultiLegWagers = totalCount > 0;

    if (totalCount >= 0) {
      result.ownProps.dispatch(setHasMultiLegWagersAction(hasMultiLegWagers));
    }

    return {};
  }
};
